
import PortalHeader from './components/portalHeader/index.vue';
import PortalFooter from './components/portalFooter/index.vue';
import portalApi from '@/apis/portalApi'
import Cookies from 'js-cookie'
import { store } from '@/store'
import { computed, defineComponent, reactive, toRefs, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import { PortalMutationTypes } from '@/store/modules/portal/mutation-types'
import { PortalActionTypes } from '@/store/modules/portal/action-types'

export default defineComponent({
  name: 'institutionalPortal',
  components: {
    PortalHeader,
    PortalFooter
  },
  setup() {
    const state = reactive({
      currentId: '',
      headerData: {  },
      footerData: {  },
      loading: computed(() => store.state.portal.portalLoading),
      isMobile: computed(() => store.state.portal.isMobile)
    })

    try {
      const meta = document.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no';
      parent.document.head.appendChild(meta)
    } catch (e) {
      console.error(e)
    }

    store.commit(PortalMutationTypes.SET_PORTAL_ISMOBILE, navigator.userAgent.includes('Mobile'));
    window.addEventListener('resize', () => {
      store.commit(PortalMutationTypes.SET_PORTAL_ISMOBILE, navigator.userAgent.includes('Mobile'));
    })

    // 去掉title
    document.title = store.state.portal.portalTitle;
    const routeQuery = useRoute().query;
    const portalToken = routeQuery.portalToken || Cookies.get('portal-token');
    if(portalToken) {
      Cookies.set('portal-token', portalToken, { expires: 30 });
      store.dispatch(PortalActionTypes.ACTION_GET_PORTAL_INFO, undefined);
      store.commit(PortalMutationTypes.SET_PORTAL_TOKEN, portalToken);
      // 替换地址
      const href = location.href;
      if(href.includes('&portalToken')) {
        location.replace(href.slice(0, href.indexOf('&portalToken')));
      }
    }
    if (typeof routeQuery.id == 'string') {
      state.currentId = routeQuery.id;
      getNavigationInfo()
      getFootInfo();
      nextTick(() => {
        getThemeSettings();
        setLoadingLogo();
      })
    }

    // 获取导航栏信息
    async function getNavigationInfo() {
      await portalApi.getNavigationInfo({microid: state.currentId}).then((res) => {
        state.headerData = res;
      })
    }

    // 获取页脚信息
    async function getFootInfo() {
      await portalApi.getFootInfo({ microid: state.currentId }).then(res => {
        state.footerData = res;
      })
    }
    // 设置loading logo
    function setLoadingLogo() {
      const wrapper = document.querySelector('.wrapper') as HTMLDivElement;
      wrapper.style.setProperty('--loading-image', `url("${ require('Assets/images/portal_loading.gif') }")`);
    }

    // 获取主题配置
    async function getThemeSettings() {
      portalApi.getThemeSettings({ microid: state.currentId }).then(res => {
        // 设置icon
        const ElIcon = document.querySelector('link[rel="shortcut icon"]') as HTMLLinkElement;
        ElIcon.href = res.favicon;

        // 设置主题色
        const themeColor = res.styleColor || '#4285F4';
        if(themeColor) {
          const themeColorArr = themeColor.split('');
          const wrapper = document.querySelector('.wrapper') as HTMLDivElement;
          wrapper.style.setProperty('--main-color-red', String(parseInt(themeColorArr[1] + themeColorArr[2], 16)));
          wrapper.style.setProperty('--main-color-green', String(parseInt(themeColorArr[3] + themeColorArr[4], 16)));
          wrapper.style.setProperty('--main-color-blue', String(parseInt(themeColorArr[5] + themeColorArr[6], 16)));
        }
      })
    }

    return {
      ...toRefs(state)
    }
  }
})
